import { Navigate, Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { RoleGuard } from '@/components/common/RoleGuard';
import { ChangePasswordPage } from '@/features/auth/pages/ChangePasswordPage';
import { ForgotPasswordPage } from '@/features/auth/pages/ForgotPasswordPage';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { AUTH_ROUTES, POST_LOGIN_ROUTE } from '@/features/auth/routes';
import { ConfiguracionPage } from '@/features/configuracion/pages/ConfiguracionPage';
import { EditarEstablecimientoPage } from '@/features/establecimientos/pages/EditarEstablecimientoPage';
import { EstablecimientosPage } from '@/features/establecimientos/pages/EstablecimientosPage';
import { NuevoEstablecimientoPage } from '@/features/establecimientos/pages/NuevoEstablecimientoPage';
import { EditarProfesionalPage } from '@/features/profesionales/pages/EditarProfesionalPage';
import { NuevoProfesionalPage } from '@/features/profesionales/pages/NuevoProfesionalPage';
import { ProfesionalesPage } from '@/features/profesionales/pages/ProfesionalesPage';
import { NuevoProtocoloPage } from '@/features/protocolos/pages/NuevoProtocoloPage';
import { ProtocoloDetailPage } from '@/features/protocolos/pages/ProtocoloDetailPage';
import { ProtocolosPage } from '@/features/protocolos/pages/ProtocolosPage';
import { MainLayout } from '@/layouts/MainLayout';
import { Rol } from '@/types/enums';

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path={AUTH_ROUTES.LOGIN} element={<LoginPage />} />
      <Route path={AUTH_ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />

      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to={POST_LOGIN_ROUTE} replace />} />

        <Route
          path="/profesionales"
          element={
            <RoleGuard allowedRoles={[Rol.ADMINISTRADOR, Rol.TECNICO_LABORATORIO]}>
              <ProfesionalesPage />
            </RoleGuard>
          }
        />
        <Route
          path="/profesionales/nuevo"
          element={
            <RoleGuard allowedRoles={[Rol.ADMINISTRADOR, Rol.TECNICO_LABORATORIO]}>
              <NuevoProfesionalPage />
            </RoleGuard>
          }
        />
        <Route
          path="/profesionales/:uidProfesional"
          element={
            <RoleGuard allowedRoles={[Rol.ADMINISTRADOR, Rol.TECNICO_LABORATORIO]}>
              <EditarProfesionalPage />
            </RoleGuard>
          }
        />

        <Route
          path="/establecimientos"
          element={
            <RoleGuard allowedRoles={[Rol.ADMINISTRADOR, Rol.TECNICO_LABORATORIO]}>
              <EstablecimientosPage />
            </RoleGuard>
          }
        />
        <Route
          path="/establecimientos/nuevo"
          element={
            <RoleGuard allowedRoles={[Rol.ADMINISTRADOR, Rol.TECNICO_LABORATORIO]}>
              <NuevoEstablecimientoPage />
            </RoleGuard>
          }
        />
        <Route
          path="/establecimientos/:uidEstablecimiento"
          element={
            <RoleGuard allowedRoles={[Rol.ADMINISTRADOR, Rol.TECNICO_LABORATORIO]}>
              <EditarEstablecimientoPage />
            </RoleGuard>
          }
        />

        <Route path="/protocolos" element={<ProtocolosPage />} />
        <Route path="/protocolos/nuevo" element={<NuevoProtocoloPage />} />
        <Route path="/protocolos/:uid" element={<ProtocoloDetailPage />} />

        <Route
          path="/configuracion"
          element={
            <RoleGuard
              allowedRoles={[Rol.ADMINISTRADOR]}
              redirectTo="/protocolos"
              denegadoMessage="No tenés permisos para acceder a esta pantalla."
            >
              <ConfiguracionPage />
            </RoleGuard>
          }
        />

        <Route path={AUTH_ROUTES.CHANGE_PASSWORD} element={<ChangePasswordPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
